import SelaTranscriptActiveHover from './component.jsx'
export default SelaTranscriptActiveHover
